import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import { AddKeyPressHandler } from '@gem/keyboard-handler';
import {
  OverlayingPopup,
  PopupHeader,
  TOverlayingPopupTheme,
  TPopupHeaderTheme,
} from '@gem/ui-kit';

import styles from './Popup.styles.m.css';

interface IPopupProps {
  className?: string;
  overlayClassName?: string;
  overlayContainerClassName?: string;
  isOpened?: boolean;
  isHidden?: boolean;
  title?: string;
  isShowHeader?: boolean;
  isIgnoreClickOutside?: boolean;
  dataTest?: string;
  handlePrevStep?: (() => void) | null;
  headerClassName?: string;
  /*
    @deprecated use headerTheme instead
   */
  theme?: TPopupHeaderTheme;
  headerTheme?: TPopupHeaderTheme;
  popupTheme?: TOverlayingPopupTheme;
  stepsCount?: number;
  currentStep?: number;
  onClose?(): void;
  onCloseByOverlay?(): void;
  onCloseByKey?(): void;
  onCloseByButton?(): void;
}

export const Popup: FC<PropsWithChildren<IPopupProps>> = (props) => {
  const {
    className,
    headerClassName,
    overlayContainerClassName,
    overlayClassName,
    isOpened,
    isHidden = false,
    title,
    isShowHeader,
    dataTest,
    handlePrevStep,
    onClose,
    onCloseByOverlay,
    onCloseByKey,
    onCloseByButton,
    stepsCount,
    currentStep,
    children,
    isIgnoreClickOutside,
    theme,
    headerTheme = theme,
    popupTheme = 'standard',
  } = props;

  return (
    <OverlayingPopup
      className={classNames(overlayContainerClassName, { [styles.hide]: isHidden })}
      isOpened={isOpened}
      popupClassName={classNames(styles.container, className)}
      overlayClassName={overlayClassName}
      isIgnoreClickOutside={isIgnoreClickOutside}
      dataTest={dataTest}
      onClose={onCloseByOverlay || onClose}
      theme={popupTheme}
    >
      <AddKeyPressHandler onEsc={onCloseByKey || onClose} />
      {(title || handlePrevStep || isShowHeader) && (
        <PopupHeader
          className={headerClassName}
          onClose={onCloseByButton || onClose}
          handlePrevStep={handlePrevStep}
          stepsCount={stepsCount}
          currentStep={currentStep}
          title={title}
          theme={headerTheme}
        />
      )}
      {children}
    </OverlayingPopup>
  );
};
